module.exports = __webpack_public_path__ + "static/img/UniXYZ.630b0c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UniLogo/UniXYZ.png
// module id = AWwj
// module chunks = 8